module.exports = __webpack_public_path__ + "static/assets/7f0a82cddbc5ea1fe391ad68d1e8036e.svg";